const waitUntil = ({ atom, predicate, rejectAfter }) => {
    let unobserve;
    let timeout;
    const promise = new Promise((resolve, reject) => {
        unobserve = atom.observe((v) => {
            if (predicate(v)) {
                clearTimeout(timeout);
                unobserve();
                resolve(v);
            }
        });
        if (rejectAfter) {
            timeout = setTimeout(() => {
                unobserve();
                reject(new Error('rejected by timeout'));
            }, rejectAfter);
        }
    });
    void Object.defineProperty(promise, 'unobserve', {
        value: () => {
            unobserve();
            clearTimeout(timeout);
        },
        writable: false,
    });
    return promise;
};
export default waitUntil;
